import React from 'react';

const GLYPHS = {
  open: '\u00b7', done: 'x', cancelled: '~', migrated: '>',
  note: '\u2014', question: '?', event: 'o', selected: '\u25b8'
};

const COLORS = {
  open: 'var(--bujo-state-open)',
  done: 'var(--bujo-state-done)',
  cancelled: 'var(--bujo-state-cancelled)',
  migrated: 'var(--bujo-state-migrated)',
  note: 'var(--bujo-state-open)',
  question: 'var(--bujo-state-open)',
  event: 'var(--bujo-state-open)',
  selected: 'var(--bujo-select-edge)'
};

const SIZES = { grid: 12, row: 15, sheet: 20, capture: 28 };

/** The signifier. A character on the mono grid — never restyled into an icon. */
export function GlyphMark({ state = 'open', size = 'row', priority = false, color, style }) {
  const px = SIZES[size] || SIZES.row;
  const col = size === 'grid' ? 'var(--bujo-glyph-12)'
    : size === 'sheet' || size === 'capture' ? 'var(--bujo-glyph-col-sheet)'
    : 'var(--bujo-glyph-col)';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, flex: 'none', ...style }}>
      <span style={{
        width: col, textAlign: 'center', flex: 'none',
        font: `var(--bujo-fw-regular) ${px}px/var(--bujo-lh-tight) var(--bujo-font-mono)`,
        color: color || COLORS[state] || COLORS.open
      }}>{GLYPHS[state] || GLYPHS.open}</span>
      {priority ? (
        <span style={{
          font: `var(--bujo-fw-bold) ${px}px/var(--bujo-lh-tight) var(--bujo-font-mono)`,
          color: 'var(--bujo-state-priority)'
        }}>!</span>
      ) : null}
    </span>
  );
}
